<template>
  <div>
    <DropdownInput
      :disabled="disabled"
      :multiple="multiple"
      :items="items"
      :modelValue="value"
      @update:modelValue="handleChange"
      name="days"
    />
  </div>
</template>

<script setup>
import { RRule } from "rrule";
import { computed, defineProps, defineEmits, toRef } from "vue";
import { useI18n } from "vue-i18n";

import DropdownInput from "@/Tailwind/Components/Input/DropdownInput";

const { t } = useI18n();
const emit = defineEmits(["change"]);

const props = defineProps({
  multiple: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  value: [Object, Array],
});

const disabled = toRef(props, "disabled");

const items = computed(() => {
  return [
    { label: t("admin.tasks.recurring.days.mo"), value: RRule.MO },
    { label: t("admin.tasks.recurring.days.tu"), value: RRule.TU },
    { label: t("admin.tasks.recurring.days.we"), value: RRule.WE },
    { label: t("admin.tasks.recurring.days.th"), value: RRule.TH },
    { label: t("admin.tasks.recurring.days.fr"), value: RRule.FR },
    { label: t("admin.tasks.recurring.days.sa"), value: RRule.SA },
    { label: t("admin.tasks.recurring.days.su"), value: RRule.SU },
  ];
});

function handleChange(days) {
  emit("change", days);
}
</script>
